
export interface LocationData {
  latitude: number | null;
  longitude: number | null;
  error?: string;
}

export const getCurrentLocation = (): Promise<LocationData> => {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve({
        latitude: null,
        longitude: null,
        error: 'Geolocalización no soportada en este navegador'
      });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        });
      },
      (error) => {
        let errorMessage = 'Error desconocido al obtener ubicación';
        
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = 'Usuario denegó el permiso de geolocalización';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = 'Información de ubicación no disponible';
            break;
          case error.TIMEOUT:
            errorMessage = 'La solicitud de geolocalización expiró';
            break;
        }
        
        resolve({
          latitude: null,
          longitude: null,
          error: errorMessage
        });
      },
      { 
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  });
};

// Guardar la ubicación seleccionada en localStorage para persistencia
export const saveSelectedProfileId = (profileId: string): void => {
  localStorage.setItem('selectedProfileId', profileId);
};

// Recuperar la ubicación seleccionada de localStorage
export const getSelectedProfileId = (): string | null => {
  return localStorage.getItem('selectedProfileId');
};
